// Seed data & defaults — Tahsin Store, Kabul, Afghanistan.

export const DEFAULT_SETTINGS = {
  brand_name_fa: "تحسین",
  brand_name_en: "Tahsin",
  tagline: "طبیعتِ افغانستان — از کندو، مزرعه و باغ تا سفرهٔ شما",
  whatsapp_number: "93707779774",
  instagram_url: "https://www.instagram.com/tahsin.honey",
  facebook_url: "https://www.facebook.com/store.tahsin",
  contact_phone: "+93 707 779 774",
  contact_phone_2: "+93 778 387 698",
  contact_email: "info@tahsin.store",
  address: "کابل، افغانستان — ارسال به سراسر افغانستان",
  developer_name: "Murtaza Mahdiyar",
  developer_url: "https://mahdiyar.dev",
};

// Landing-page editable content
export const DEFAULT_LANDING = {
  hero: {
    badge: "۱۰۰٪ طبیعی · مستقیم از تولیدکننده",
    title_top: "طبیعتِ اصیل افغانستان،",
    title_highlight: "از کندو تا سفرهٔ شما",
    subtitle:
      "تحسین، مجموعه‌ای از بهترین عسل‌های خالص، زعفران سرگل هرات و محصولات طبیعی از سراسر افغانستان — با احترام به زنبوردار، کشاورز و باغ‌دار افغان، بدون افزودنی به دست شما می‌رسد.",
    cta_primary: "کاتالوگ محصولات",
    cta_secondary: "سفارش سریع در واتساپ",
    background_image:
      "https://images.pexels.com/photos/4198717/pexels-photo-4198717.jpeg?auto=compress&w=2000",
  },
  trust_badges: [
    { label: "کیفیت تضمینی", icon: "ShieldCheck" },
    { label: "بدون افزودنی", icon: "Leaf" },
    { label: "ارسال سراسر افغانستان", icon: "Truck" },
  ],
  categories_section: {
    eyebrow: "کاتالوگ تحسین",
    title: "دسته‌بندی محصولات",
    subtitle: "هر چه طبیعت افغانستان سخاوتمندانه به ما بخشیده",
  },
  featured_section: {
    eyebrow: "انتخاب ویژه",
    title: "محصولات پرطرفدار تحسین",
  },
  our_story: {
    eyebrow: "داستان ما",
    title_top: "قصه تحسین،",
    title_bottom: "قصه احترام به طبیعت افغانستان",
    body: [
      "تحسین از یک باور ساده شروع شد: غذای واقعی باید همان‌طور که طبیعت به ما هدیه داده، به دست مصرف‌کننده برسد. بدون افزودنی، بدون فرآوری غیرضروری و با احترام به زنبوردار و کشاورز افغان.",
      "ما با زنبورداران بدخشان و کندز، کشاورزان زعفران هرات و باغ‌داران پروان، ارزگان، کندهار و نورستان ارتباط مستقیم داریم. هر محصول پیش از ارسال به شما، با دقت بررسی می‌شود.",
    ],
    cta_label: "بیشتر بدانید",
    image:
      "https://images.pexels.com/photos/4198565/pexels-photo-4198565.jpeg?auto=compress&w=1200",
  },
  articles_section: {
    eyebrow: "خوانده شود",
    title: "مقالات و یادداشت‌های علمی",
  },
  cta_band: {
    title: "هنوز مطمئن نیستید؟",
    body:
      "با ما در واتساپ یا مسنجر فیسبوک تماس بگیرید. پاسخگوی سوالات شما درباره محصولات، قیمت‌ها و روش‌های ارسال خواهیم بود.",
    cta_label: "گفتگو در واتساپ",
  },
};

export const DEFAULT_ABOUT = {
  eyebrow: "درباره ما",
  title: "قصه تحسین، قصه اعتماد",
  intro_paragraphs: [
    "تحسین از یک دغدغه ساده شکل گرفت: چرا پیدا کردن عسل واقعی این‌قدر سخت شده است؟ چرا زعفران اصیل افغانستان در بازار خودمان کمیاب است؟ چرا میوه‌های خشک بی‌نظیر باغ‌های افغانستان به بهترین نحو عرضه نمی‌شوند؟",
    "ما این مسیر را با ارتباط مستقیم با زنبورداران بدخشان و کندز، کشاورزان زعفران هرات و باغ‌داران پروان، ارزگان، کندهار و نورستان شروع کردیم. هدف ما این است که هر آن‌چه طبیعت افغانستان سخاوتمندانه به ما ارزانی داشته، بدون واسطه‌های غیرضروری و با حفظ بالاترین کیفیت به خانهٔ شما برسد.",
  ],
  image:
    "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg?auto=compress&w=1400",
  values_title: "ارزش‌های ما",
  values: [
    { icon: "Leaf", title: "طبیعی و خالص", desc: "محصولات ما بدون افزودنی، رنگ مصنوعی یا مواد نگهدارنده به دست شما می‌رسد." },
    { icon: "ShieldCheck", title: "کیفیت تضمین‌شده", desc: "هر محصول پیش از ارسال توسط تیم ما بررسی و تایید می‌شود." },
    { icon: "Heart", title: "احترام به تولیدکننده", desc: "ارتباط مستقیم با زنبورداران و باغ‌داران افغان، بدون واسطه‌های غیرضروری." },
    { icon: "Sprout", title: "پایداری", desc: "ما به محیط زیست و نسل‌های آینده احترام می‌گذاریم." },
  ],
};

export const DEFAULT_CONTACT = {
  eyebrow: "ارتباط با تحسین",
  title: "تماس با ما",
  intro:
    "برای سفارش محصولات، مشاوره یا همکاری از هر جای افغانستان با ما در تماس باشید. سریع‌ترین راه، پیام در واتساپ یا مسنجر فیسبوک است.",
  whatsapp_subtitle: "برای سفارش و مشاوره سریع",
  instagram_subtitle: "محتوای روزانه و پشت‌صحنه",
  facebook_subtitle: "صفحه رسمی تحسین",
  email_subtitle: "برای همکاری و روابط عمومی",
  phone_subtitle: "شنبه تا پنجشنبه، ۹ صبح تا ۶ عصر",
  address_subtitle: "دفتر مرکزی و ارسال",
};

export const DEFAULT_CATEGORIES = [
  {
    key: "honey",
    name_fa: "عسل طبیعی",
    description: "عسل خالص از کوهستان‌ها و دشت‌های افغانستان",
    image:
      "https://images.pexels.com/photos/18581552/pexels-photo-18581552.jpeg?auto=compress&w=1000",
    icon: "Droplet",
  },
  {
    key: "saffron",
    name_fa: "زعفران هرات",
    description: "زعفران سرگل و درجه یک از هرات — طلای سرخ افغانستان",
    image:
      "https://images.pexels.com/photos/4198717/pexels-photo-4198717.jpeg?auto=compress&w=1000",
    icon: "Flower2",
  },
  {
    key: "dried_fruit",
    name_fa: "میوه خشک",
    description: "کشمش، مویز، توت، بادام و پسته از ولایات افغانستان",
    image:
      "https://images.pexels.com/photos/9508582/pexels-photo-9508582.jpeg?auto=compress&w=1000",
    icon: "Grape",
  },
  {
    key: "other",
    name_fa: "سایر محصولات",
    description: "جلغوزه، گرده گل و محصولات طبیعی ویژه",
    image:
      "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg?auto=compress&w=1000",
    icon: "Leaf",
  },
];

export const DEFAULT_PRODUCTS = [
  {
    id: "seed-1",
    name: "عسل سیاه‌دانه کوهی",
    slug: "asal-siahdana",
    category: "honey",
    short_description: "عسل خالص سیاه‌دانه از کوهستان‌های شمال افغانستان",
    description:
      "عسل سیاه‌دانه یکی از بی‌نظیرترین عسل‌های افغانستان است که از شهد گل سیاه‌دانه در کوهستان‌های شمال کشور به‌دست می‌آید.\n\n- رنگ: کهربایی روشن\n- طعم: ملایم با کمی تلخی دلپذیر\n- وزن: ۹۰۰ گرم\n- برداشت: ولایات بدخشان و کندز",
    price_afn: 1400,
    weight: "۹۰۰ گرم",
    images: [
      "https://images.pexels.com/photos/18581552/pexels-photo-18581552.jpeg?auto=compress&w=1200",
      "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg?auto=compress&w=1200",
    ],
    tags: ["عسل", "سیاه‌دانه", "بدخشان"],
    in_stock: true,
    featured: true,
    created_at: "2026-04-01T00:00:00Z",
  },
  {
    id: "seed-2",
    name: "عسل کوهی افغانستان",
    slug: "asal-kohi",
    category: "honey",
    short_description: "عسل چندگل از ارتفاعات هندوکش — معطر و با کیفیت",
    description:
      "عسل چندگل کوهستانی، حاصل فعالیت زنبور روی گل‌های وحشی ارتفاعات هندوکش. غنی از آنتی‌اکسیدان‌ها. مستقیم از زنبورداران محلی پروان و پنجشیر.",
    price_afn: 1100,
    weight: "۹۰۰ گرم",
    images: ["https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg?auto=compress&w=1200"],
    tags: ["عسل", "کوهستان", "هندوکش"],
    in_stock: true,
    featured: true,
    created_at: "2026-04-02T00:00:00Z",
  },
  {
    id: "seed-3",
    name: "زعفران سرگل هرات — درجه یک",
    slug: "zafaran-sargol-herat",
    category: "saffron",
    short_description: "زعفران سرگل مستقیم از مزارع هرات — طلای سرخ افغانستان",
    description:
      "زعفران سرگل هرات، رنگ و عطر درجه یک جهانی. برداشت‌شده با دست از مزارع شهرستان‌های هرات، در بسته‌بندی بهداشتی.\n\n- نوع: سرگل (تمام رشته سرخ)\n- وزن: ۱ گرم\n- منبع: مزارع هرات\n- کیفیت: درجه یک صادراتی",
    price_afn: 1800,
    weight: "۱ گرم",
    images: [
      "https://images.pexels.com/photos/4198717/pexels-photo-4198717.jpeg?auto=compress&w=1200",
      "https://images.pexels.com/photos/4198565/pexels-photo-4198565.jpeg?auto=compress&w=1200",
    ],
    tags: ["زعفران", "هرات", "سرگل"],
    in_stock: true,
    featured: true,
    created_at: "2026-04-03T00:00:00Z",
  },
  {
    id: "seed-4",
    name: "زعفران پوشال هرات",
    slug: "zafaran-poshal-herat",
    category: "saffron",
    short_description: "زعفران پوشال هرات با قیمت اقتصادی و کیفیت بالا",
    description: "زعفران پوشال (دارای مقدار کمی از ریشه زرد)، انتخاب اقتصادی برای استفاده روزانه. هنوز کاملاً طبیعی و بدون افزودنی.",
    price_afn: 1200,
    weight: "۱ گرم",
    images: ["https://images.pexels.com/photos/4198565/pexels-photo-4198565.jpeg?auto=compress&w=1200"],
    tags: ["زعفران", "هرات", "پوشال"],
    in_stock: true,
    featured: true,
    created_at: "2026-04-04T00:00:00Z",
  },
  {
    id: "seed-5",
    name: "کشمش سبز ارغوان",
    slug: "keshmesh-arghawan",
    category: "dried_fruit",
    short_description: "کشمش سبز درشت از تاکستان‌های پروان و کاپیسا",
    description: "کشمش سبز ارغوان، شیرین طبیعی و بدون گوگرد از تاکستان‌های پروان و کاپیسا.",
    price_afn: 450,
    weight: "۵۰۰ گرم",
    images: ["https://images.pexels.com/photos/7474897/pexels-photo-7474897.jpeg?auto=compress&w=1200"],
    tags: ["کشمش", "پروان", "کاپیسا"],
    in_stock: true,
    featured: false,
    created_at: "2026-04-05T00:00:00Z",
  },
  {
    id: "seed-6",
    name: "بادام کاغذی ارزگان",
    slug: "badam-kaghazi",
    category: "dried_fruit",
    short_description: "بادام کاغذی خوش‌طعم و پوست‌نازک از ارزگان",
    description: "بادام کاغذی ارزگان، یکی از بهترین بادام‌های افغانستان. پوست‌نازک و مغز درشت با طعم بی‌نظیر.",
    price_afn: 750,
    weight: "۵۰۰ گرم",
    images: ["https://images.pexels.com/photos/9508582/pexels-photo-9508582.jpeg?auto=compress&w=1200"],
    tags: ["بادام", "ارزگان"],
    in_stock: true,
    featured: true,
    created_at: "2026-04-06T00:00:00Z",
  },
  {
    id: "seed-7",
    name: "پسته کندهار",
    slug: "pesteh-kandahar",
    category: "dried_fruit",
    short_description: "پسته وحشی کوهستان‌های کندهار با طعم اصیل",
    description: "پسته وحشی از کوهستان‌های کندهار، ریزتر ولی بسیار معطرتر و خوشمزه‌تر.",
    price_afn: 950,
    weight: "۵۰۰ گرم",
    images: ["https://images.pexels.com/photos/7474897/pexels-photo-7474897.jpeg?auto=compress&w=1200"],
    tags: ["پسته", "کندهار"],
    in_stock: true,
    featured: false,
    created_at: "2026-04-07T00:00:00Z",
  },
  {
    id: "seed-8",
    name: "جلغوزه نورستان",
    slug: "jalghoozeh",
    category: "other",
    short_description: "جلغوزه (دانه صنوبر) از جنگل‌های نورستان",
    description: "جلغوزه از جنگل‌های نورستان و کنر. غنی از پروتئین و روغن‌های مفید.",
    price_afn: 1500,
    weight: "۲۵۰ گرم",
    images: ["https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg?auto=compress&w=1200"],
    tags: ["جلغوزه", "نورستان"],
    in_stock: true,
    featured: true,
    created_at: "2026-04-08T00:00:00Z",
  },
];

export const DEFAULT_ARTICLES = [
  {
    id: "art-1",
    slug: "khavas-asal",
    title: "چرا عسل طبیعی افغانستان خاص است؟",
    excerpt: "نگاهی علمی به خواص عسل خالص و تفاوت آن با عسل‌های صنعتی در بازار.",
    content:
      "# چرا عسل طبیعی افغانستان خاص است؟\n\nعسل، یکی از قدیمی‌ترین غذاهای شناخته‌شده بشر است. در افغانستان، تنوع گیاهی و ارتفاعات کوهستانی باعث شده عسل‌های این سرزمین ویژگی‌های منحصربه‌فردی داشته باشند.\n\n## ۱. تنوع جغرافیایی بی‌نظیر\nاز کوهستان‌های بدخشان تا دشت‌های کندهار، هر منطقه عسل با طعم و رنگ خاص خود تولید می‌کند.\n\n## ۲. خواص درمانی شناخته‌شده\n- تقویت سیستم ایمنی بدن\n- آنتی‌اکسیدان قوی\n- کمک به بهبود خواب\n- تسکین سرفه و گلودرد\n\n## ۳. چطور اصل از تقلبی را بشناسیم؟\n**بافت**: عسل اصل در دمای پایین تبلور طبیعی پیدا می‌کند.\n**طعم**: عطر گل‌هایی که زنبور از آن‌ها تغذیه کرده در طعم حضور دارد.\n\nدر تحسین، عسل‌های ما مستقیم از زنبورداران ولایات بدخشان، کندز، پروان و پنجشیر تهیه می‌شود — بدون افزودنی، بدون حرارت‌دهی.",
    cover_image: "https://images.pexels.com/photos/17585229/pexels-photo-17585229.jpeg?auto=compress&w=1600",
    author: "داکتر مریم احمدی",
    tags: ["عسل", "سلامت"],
    published: true,
    created_at: "2026-04-10T10:00:00Z",
  },
  {
    id: "art-2",
    slug: "zafaran-herat",
    title: "زعفران هرات — طلای سرخ افغانستان",
    excerpt: "چرا زعفران هرات در دنیا معروف و بهترین است؟ نگاهی به تاریخ و کیفیت این محصول ارزشمند.",
    content:
      "# زعفران هرات — طلای سرخ افغانستان\n\nزعفران هرات در چند سال گذشته به‌عنوان یکی از **بهترین زعفران‌های جهان** شناخته شده و جوایز بین‌المللی متعددی کسب کرده است.\n\n## چرا هرات؟\nشرایط آب و هوایی منحصربه‌فرد هرات — زمین‌های مرتفع، خشکی مناسب و تفاوت دمایی شب و روز — بهترین محیط برای پرورش زعفران را فراهم می‌کند.\n\n## انواع زعفران\n### ۱. سرگل (Sargol)\nتنها قسمت سرخ رشته — بالاترین کیفیت.\n\n### ۲. پوشال (Poushal)\nدارای مقداری از ریشه زرد، کیفیت عالی، قیمت اقتصادی‌تر.\n\n## خواص زعفران\n- ضدافسردگی طبیعی\n- آنتی‌اکسیدان قوی\n- کمک به بهبود حافظه\n\nزعفران تحسین مستقیم از کشاورزان هرات تهیه می‌شود — بدون واسطه، با ضمانت اصالت.",
    cover_image: "https://images.pexels.com/photos/4198717/pexels-photo-4198717.jpeg?auto=compress&w=1600",
    author: "مهندس علی رضایی",
    tags: ["زعفران", "هرات"],
    published: true,
    created_at: "2026-04-12T10:00:00Z",
  },
  {
    id: "art-3",
    slug: "miveh-khoshk-afghan",
    title: "میوه‌های خشک افغانستان — میراث باغ‌های سنتی",
    excerpt: "از کشمش ارغوان پروان تا بادام کاغذی ارزگان — نگاهی به بهترین میوه‌های خشک افغانستان.",
    content:
      "# میوه‌های خشک افغانستان\n\nافغانستان یکی از بزرگ‌ترین تولیدکنندگان میوه‌های خشک در منطقه است.\n\n## کشمش ارغوان\nاز درختان انگور پروان و کاپیسا، درشت و شیرین.\n\n## بادام کاغذی ارزگان\nپوست‌نازک، مغز درشت و معطر.\n\n## پسته وحشی کندهار\nریزتر ولی بسیار معطرتر از پسته‌های پرورشی.\n\n## جلغوزه نورستان\nدانه صنوبر — یکی از گران‌بهاترین خشکبار جهانی.\n\n## چرا تحسین؟\n- بدون گوگرد و مواد نگهدارنده\n- خشک‌شده با روش سنتی\n- مستقیم از باغ‌داران محلی",
    cover_image: "https://images.pexels.com/photos/9508582/pexels-photo-9508582.jpeg?auto=compress&w=1600",
    author: "استاد حکیم رضوی",
    tags: ["میوه خشک", "افغانستان"],
    published: true,
    created_at: "2026-04-14T10:00:00Z",
  },
];
